export default __webpack_public_path__ + "./images/recipes-1.png";